import { css } from '@emotion/react'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import { useSearchParams } from 'react-router-dom'

import { tJosa } from '~/@app/i18n'
import { useStudentAppMediaQuery } from '~/@common/hooks/useMediaQuery'
import { useRepository } from '~/@common/hooks/useRepository'
import authService from '~/@common/services/auth.service'
import { commonRepo } from '~/@common/services/repo.service'
import { typo } from '~/@common/styles'
import { PortalRootLayoutHeader } from '~/@common/ui/PortalRootLayoutHeader'
import { getEntrancePage } from '~/@common/utils/getEntrancePage'
import GlobalHeader from '~/@pages/@widgets/(Navigation)/GlobalHeader/GlobalHeader'

import { LectureService } from '../../@service/Lecture.service'
import LectureGroupList from '../../@widgets/LectureGroupList.widget'

const SignatureWorkbookLectureListPage = () => {
  const service = useRepository(LectureService)
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const { isMobile } = useStudentAppMediaQuery()

  useEffect(() => {
    const curriculumKey = searchParams.get('curriculumKey')

    if (!curriculumKey) {
      navigate(getEntrancePage(authService.userType))
      return
    }

    if (commonRepo.studentId) {
      service
        .fetchSetLectureGroups(
          { trieKey: curriculumKey, studentId: commonRepo.studentId },
          'MIDDLE_CHAPTER',
        )
        .catch(() => {
          navigate(getEntrancePage(authService.userType))
        })
    }
  }, [searchParams, commonRepo.studentId])

  if (
    !service.lectureGroups ||
    service.lectureGroups.length === 0 ||
    service.lectureGroups[0].middleChapterLectures.length === 0
  ) {
    return <></>
  }

  return (
    <>
      <PortalRootLayoutHeader>
        <GlobalHeader
          SlotCenter={tJosa('강의')}
          prevLinkProps={{
            onClick: (e) => {
              e.preventDefault()
              navigate(getEntrancePage(authService.userType))
            },
          }}
        ></GlobalHeader>
      </PortalRootLayoutHeader>
      <div css={S.container}>
        {isMobile ? (
          <header css={S.header}>
            <div css={S.headerLeft}>
              <img
                src="/images/lecture-teacher.png"
                width={60}
                height={60}
                alt={`${tJosa('강의')} 선생님`}
              />
              <div css={S.textWrapper}>
                <div css={S.title}>
                  {service.lectureGroups[0].middleChapterLectures[0].bigChapterName}
                </div>
                <div css={S.subTitle}>다음 {tJosa('강의', '을/를')} 보고 학습할 수 있어요.</div>
              </div>
            </div>
          </header>
        ) : (
          <div css={S.subTitleStandalone}>다음 {tJosa('강의', '을/를')} 보고 학습할 수 있어요.</div>
        )}
        <LectureGroupList lectureGroups={service.lectureGroups} isFetching={service.isFetching} />
      </div>
    </>
  )
}

export default observer(SignatureWorkbookLectureListPage)

const S = {
  container: css`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
  header: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  headerLeft: css`
    display: flex;
    align-items: center;
    gap: 11px;
  `,
  textWrapper: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 2px;
    margin-bottom: 9px;
  `,
  title: css`
    color: var(--Colors-Gray-900);
    ${typo.heading04};
    font-weight: 700;
  `,
  subTitle: css`
    color: var(--Colors-Gray-700);
  `,
  subTitleStandalone: css`
    color: var(--Colors-Gray-700);
    margin-bottom: 16px;
  `,
}
